<div class="expansable-card-container" [class.is-change-plan]="isChangePlan">
  <div class="cards-list">
    <div
      class="expansable-card"
      *ngFor="let plan of plans || []; let i = index"
      [class.selected]="selectedPlanId === i"
      [class.is-current-plan]="currentPlanId === i"
      (click)="selectPlan(i)"
    >
      <div class="card-content">
        <div class="header-section" #planHeader [class.header-section--flag-below]="flagBelowPrice[i]">
          <div class="plan-name-wrapper">
            <span class="plan-name">{{ plan.name }}</span>
            <span *ngIf="isBlackFridayPlan(plan.name)" class="bf-flag">BLACK FRIDAY</span>
            <span *ngIf="currentPlanId === i" class="current-plan-badge">
              {{ 'pages.planDetails.ChangePlanModal.currentPlan' | i18n }}
            </span>
          </div>
          <div class="price-section">
            <span class="price-label">{{ 'components.expansableCard.priceLabel' | i18n }}</span>
            <div class="price">
              <span class="currency">R$</span>
              <span class="amount font-highlight">{{ formatPrice(plan.price).split(',')[0] }}</span>
              <span class="cents">,{{ formatPrice(plan.price).split(',')[1] }}</span>
              <span class="period">{{ getPeriodLabelKey(plan) | i18n }}</span>
            </div>
            <span
              *ngIf="isBlackFridayPlan(plan.name) && flagBelowPrice[i]"
              class="bf-flag bf-flag--under-price"
            >BLACK FRIDAY</span>
            <span class="fidelity" *ngIf="plan.paymentRecurrence === 'annual' && !isRegistryDomainPlan(plan)">{{ 'components.expansableCard.fidelity' | i18n }}</span>
          </div>
        </div>

        <div class="mobile-section" *ngIf="!isChangePlan">
          <div class="controls-section">
            <div class="quantity-selector">
              <button class="quantity-button" (click)="decrementQuantity($event)">-</button>
              <div class="quantity-display">{{ quantity }}</div>
              <button class="quantity-button" (click)="incrementQuantity($event)">+</button>
            </div>
            <span *ngIf="isBlackFridayPlan(plan.name)" class="bf-flag bf-flag--mobile">BLACK FRIDAY</span>
            <button class="add-cart-button" (click)="onAddToCart()">
              <i class="bi bi-cart"></i>
              {{ actionLabel | i18n }}
            </button>
          </div>

          <div class="details-toggle" (click)="toggleMobileDetails(i); $event.stopPropagation()">
            <span class="details-text">{{ 'components.expansableCard.detailsToggle' | i18n }}</span>
            <span class="expand-icon">
              <i
                [class.bi-chevron-down]="!isMobileDetailsOpen(i)"
                [class.bi-chevron-up]="isMobileDetailsOpen(i)"
                class="bi"
              ></i>
            </span>
          </div>

          <div class="card-details" *ngIf="isMobileDetailsOpen(i)">
            <p class="details-description" [innerHTML]="sanitizedDescription"></p>
            <ul class="details-list">
              <li *ngFor="let feature of plan.features">{{ feature }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="desktop-details-card" *ngIf="plans && plans.length > 0 && plans[selectedPlanId] && !isChangePlan">
    <div class="details-header">
      <span class="plan-name">{{ plans[selectedPlanId].name }}</span>
    </div>
    <div class="details-content">
      <div class="plan-description">
        <p [innerHtml]="sanitizedDescription"></p>
        <ul class="features-list">
          <li *ngFor="let feature of plans[selectedPlanId].features">{{ feature }}</li>
        </ul>
      </div>
      <div class="controls-section">
        <div class="quantity-selector">
          <button class="quantity-button" (click)="decrementQuantity($event)">-</button>
          <div class="quantity-display">{{ quantity }}</div>
          <button class="quantity-button" (click)="incrementQuantity($event)">+</button>
        </div>
        <button class="add-cart-button" (click)="onAddToCart()">
          <i class="bi bi-cart"></i>
          {{ actionLabel | i18n }}
        </button>
      </div>
    </div>
  </div>
</div>